module.exports = __webpack_public_path__ + "img/image 17.a930f4a2.png";